import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid
} from 'recharts';
import {
    chartMargin,
    chartBarColor,
    chartBarSize,
    chartGridStyle,
    tooltipPaperStyle
} from '../../../styles/CalculateMoney/Charts/ChartsCommonStyles';

const getChartData = (arr) => {
    return Array.isArray(arr)
        ? arr.map(y => ({
            year: y.year,
            earnings: y.totalEarnings,
            sessionCount: y.sessionCount,
        }))
        : [];
};

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length > 0) {
        const { year, earnings, sessionCount } = payload[0].payload;
        return (
            <div style={tooltipPaperStyle}>
                <b>{year}</b><br />
                <span style={{ fontSize: 18 }}>Earnings: €{earnings}</span><br />
                Sessions: {sessionCount}
            </div>
        );
    }
    return null;
};

const EarningsBarChartYearly = ({ yearlyDetails }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const chartData = getChartData(yearlyDetails);
    return (
        <ResponsiveContainer width="100%" height={isMobile ? 170 : 300}>
            <BarChart
                data={chartData}
                margin={chartMargin}
            >
                <CartesianGrid {...chartGridStyle} />
                <XAxis dataKey="year" tick={{ fontSize: isMobile ? 10 : 13 }} />
                <YAxis tick={{ fontSize: isMobile ? 10 : 13 }} />
                <Tooltip content={<CustomTooltip />} />
                <Bar
                    dataKey="earnings"
                    fill={chartBarColor}
                    barSize={isMobile ? 17 : chartBarSize.yearly}
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default EarningsBarChartYearly;